import { api } from '@/utils/api'

import { ApiResponseHandler, Postable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 学習結果登録API
 */
export namespace ApiTaCt030 {
  // POST parameters
  export namespace Post {
    // API Request
    interface StudyTimeNode {
      startTime: string // 開始時間（yyyy/MM/dd hh:mm:ss）
      studyTime: string // 学習時間（mm:ss）
    }
    interface PieceNode {
      reLearning: number // 解き直し回数
      contentId: string // 学習コンテンツID
      questionNum: number // 問題番号（大問の場合は0で、大問に紐づく枝問の場合は1始まりのシーケンス番号）
      answerRight: string // 正誤判定結果
      userAnswer: string // ユーザ回答内容
      studyTimes: StudyTimeNode[] // 学習時間リスト
    }
    export interface Request {
      body: {
        courseId: string // コースID
        planId: string // プランID
        unitId: string // 配信単位ID
        pieceId: string // 学習コマID
        piece: PieceNode[] // 学習コマコンテンツ
      }
    }

    // API Response
    export interface Response {
      showPuchipoPointModal: boolean // ぷちぽ獲得モーダル表示フラグ
      puchipoNum: number // ぷちぽ数
    }
  }

  // API Path
  export const path: string = '/ta/progressInfo'

  // API本体
  export class Api extends ApiBase implements Postable<Post.Request, Post.Response, ResponseError> {
    // POST
    public post<R>(
      params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Post.Response = {
        showPuchipoPointModal: false,
        puchipoNum: 0,
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Post.Response, ResponseError, R>(
        api.post<Post.Response>(path, params.body),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
